<template>
  <div class="col" v-if="firstLoading">
    <skeleton-loading>
      <row>
        <square-skeleton :boxProperties="{bottom: '10px', height: '30px'}"></square-skeleton>
      </row>
      <row>
        <square-skeleton :boxProperties="{bottom: '10px', height: '200px'}"></square-skeleton>
      </row>
    </skeleton-loading>
  </div>
  <div class="tile" v-else>
    <h3 class="tile-title is-line is-fixed-btn">{{ $t('personalInfo') }}
      <div class="tile-title__btn">
        <i class="icon24-edit-circle-primary h-cursor-pointer" :disabled="loading" @click="edit" v-if="!showForm"></i>
      </div>
    </h3>
    <div class="tile-body text-primary text-center" v-if="loading">
      <b-spinner></b-spinner>
    </div>
    <div class="tile-body" v-else>
      <div class="form-horizontal is-label-right" v-if="!showForm">
        <div class="form-group row">
          <label class="control-label col-md-3">{{ $t('name') }}</label>
          <div class="col-md-6">
            <span @click="edit" class="form-control-plaintext">{{ formModel.name }}</span>
          </div>
        </div>
        <div class="form-group row">
          <label class="control-label col-md-3">{{ $t('password') }}</label>
          <div class="col-md-6">
            <a class="btn-link form-control-plaintext text-blue" @click="showPasswordForm" href="javascript:;">{{ $t('changePassword') }}</a>
          </div>
        </div>
        <div class="form-group row">
          <label class="control-label col-md-3">{{ $t('email') }}</label>
          <div class="col-md-6">
            <span @click="edit" class="form-control-plaintext">{{ formModel.email }}</span>
          </div>
        </div>
        <div class="form-group row">
          <label class="control-label col-md-3">{{ $t('phone') }}</label>
          <div class="col-md-6">
            <span @click="edit" class="form-control-plaintext">{{ formModel.phone ? formModel.phone : $t('unknown') }}</span>
          </div>
        </div>
        <div class="form-group row">
          <label class="control-label col-md-3">{{ $t('ext') }}</label>
          <div class="col-md-6">
            <span @click="edit" class="form-control-plaintext">{{ formModel.ext ? formModel.ext : $t('unknown') }}</span>
          </div>
        </div>
        <div class="form-group row">
          <label class="control-label col-md-3">{{ $t('desc') }}</label>
          <div class="col-md-6">
            <span @click="edit" class="form-control-plaintext">{{ formModel.desc ? formModel.desc : $t('unknown') }}</span>
          </div>
        </div>
        <div class="form-group row">
          <label class="control-label col-md-3">{{ $t('language') }}</label>
          <div class="col-md-6">
            <span @click="edit" class="form-control-plaintext">{{ formModel.language ? $t(formModel.language) : $t(this.defaultLang) }}</span>
          </div>
        </div>
      </div>
      <form class="form-horizontal is-label-right" v-else @submit.prevent="save">
        <div class="form-group row">
          <label class="control-label col-md-3">{{ $t('name') }}</label>
          <div class="col-md-6">
            <form-input type="text" :model="formModel" attribute="name" :errors="formErrors"></form-input>
          </div>
        </div>
        <div class="form-group row">
          <label class="control-label col-md-3">{{ $t('email') }}</label>
          <div class="col-md-6">
            <form-input type="email" :model="formModel" attribute="email" :errors="formErrors"></form-input>
          </div>
        </div>
        <div class="form-group row">
          <label class="control-label col-md-3">{{ $t('phone') }}</label>
          <div class="col-md-6">
            <form-input type="text" :model="formModel" attribute="phone" :errors="formErrors"></form-input>
          </div>
        </div>
        <div class="form-group row">
          <label class="control-label col-md-3">{{ $t('desc') }}</label>
          <div class="col-md-6">
            <form-textarea :model="formModel" attribute="desc" :errors="formErrors"></form-textarea>
          </div>
        </div>
        <div class="form-group row">
          <label class="control-label col-md-3">{{ $t('language') }}</label>
          <div class="col-md-6">
            <form-select :model="formModel" attribute="language" :errors="formErrors" :options="languages"></form-select>
          </div>
        </div>
        <hr>
        <div class="form-group row">
          <div class="col-md-6 offset-md-3">
            <button class="btn btn-primary mr-2" type="submit" :disabled="saveLoading">
              <b-spinner v-if="saveLoading" small></b-spinner>
              <span v-else>{{ $t('save') }}</span>
            </button>
            <button class="btn btn-secondary" @click="cancel">{{ $t('cancel') }}</button>
          </div>
        </div>
      </form>
    </div>
    <b-modal v-model="passwordForm" :title="$t('changePassword')" @ok="savePassword" @close="clearPasswordForm" @cancel="clearPasswordForm" :no-close-on-backdrop="true" :no-enforce-focus="true">
      <form @submit.prevent="savePassword" autocomplete="off">
        <form-input :label="$t('oldPassword')" type="password" :model="passwordModel" attribute="oldPassword" :errors="errors" :placeholder="$t('oldPasswordPlaceholder')"></form-input>
        <form-input :label="$t('newPassword')" type="password" :model="passwordModel" attribute="password" :errors="errors" :placeholder="$t('newPasswordPlaceholder')"></form-input>
        <form-input :label="$t('rePassword')" type="password" :model="passwordModel" attribute="rePassword" :errors="errors" :placeholder="$t('rePasswordPlaceholder')"></form-input>
      </form>
      <template v-slot:modal-footer>
        <b-button variant="secondary" class="float-right" @click="clearPasswordForm">{{ $t('cancel') }}</b-button>
        <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="savePassword">
          <b-spinner v-if="saveLoading" small></b-spinner>
          {{ $t('changePassword') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      formModel: {},
      passwordModel: {},
      loading: false,
      saveLoading: false,
      firstLoading: true,
      showForm: false,
      passwordForm: false,
      formErrors: {},
      errors: {},
      defaultLang: this.$store.state.user.client.country.languageCode,
      languages: [
        {value: 'vi', text: this.$t('vi')},
        {value: 'en', text: this.$t('en')}
      ]
    };
  },
  methods: {
    load() {
      let loadingTimeout = setTimeout(() => {
        this.loading = true;
      }, 250);
      this.$service.get('/profile').then(response => {
        this.formModel = response.data;
        this.firstLoading = false;
      }).finally(() => {
        this.loading = false;
        clearTimeout(loadingTimeout);
      });
    },
    edit() {
      this.load();
      this.showForm = true;
    },
    save() {
      this.saveLoading = true;
      if (this.formModel.language) {
        this.setLocale(this.formModel.language);
      }
      this.$service({url: '/profile', method: 'put', data: this.formModel}).then(response => {
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t(this.formModel.id ? 'updated' : 'created'),
            icon: 'success',
            toast: true,
            position: 'top-end',
            timer: 5000,
          });
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t(this.formModel.id ? 'updateFailed' : 'createFailed'),
            icon: 'error',
            toast: true,
            position: 'top-end',
            timer: 5000,
          });
        }
        this.load();
        this.showForm = false;
      }).catch(error => {
        if (error.response.data.msg) {
          this.$swal({
            text: error.response.data.msg,
            icon: 'error'
          });
          this.showForm = false;
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        this.saveLoading = false;
      });
    },
    cancel() {
      this.load();
      this.showForm = false;
    },
    showPasswordForm() {
      this.passwordForm = true;
    },
    clearPasswordForm() {
      this.passwordForm = false;
      this.passwordModel = {};
    },
    savePassword: function (evt) {
      evt.preventDefault();
      this.saveLoading = true;
      this.errors = {};
      this.$service.put('/profile/password', this.passwordModel).then(response => {
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t('passwordUpdated'),
            icon: 'success'
          });
          localStorage.removeItem('token');
          this.$service.defaults.headers.common['token'] = null;
          this.$bgService.defaults.headers.common['token'] = null;
          this.$store.commit('user', null);
          location.href = '#/login';
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t('passwordUpdateFailed'),
            icon: 'error'
          });
        }
        this.passwordModel = {};
        this.$store.commit('showPasswordForm', false);
      }).catch(error => {
        this.errors = error.response.data;
      }).finally(() => {
        this.saveLoading = false;
      });
    },
    setLocale: function (locale) {
      this.$i18n.locale = locale;
      this.$service.defaults.headers.common['Accept-Language'] = locale;
      this.$bgService.defaults.headers.common['Accept-Language'] = locale;
      localStorage.setItem('locale', locale);
    }
  },
  mounted() {
    this.firstLoading = true;
    this.load();
  }
}
</script>